export default {
  "content": "<circle cx=\"256\" cy=\"160\" r=\"128\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M143.65 227.82L48 400l86.86-.42a16 16 0 0113.82 7.8L192 480l88.33-194.32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M366.54 224L464 400l-86.86-.42a16 16 0 00-13.82 7.8L320 480l-64-140.8\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"160\" r=\"64\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};